// import { Router } from '@angular/router'
import { Component, OnInit } from '@angular/core'
import { XpService } from './xp.service'
import { faChartBar, faShoppingCart, faUserCircle, faBoxOpen, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  count = 0
  title = 'StoreShop.no'
  public config: any
  settings = { user: undefined, customer: '', isLoggedIn: false }
  userIcon = faUserCircle
  cartIcon = faShoppingCart
  logoutIcon = faSignOutAlt
  cache = {}

  constructor(public xp: XpService) {
    let cart = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : []
    let count = 0
    cart.forEach((line) => count += line.count )
    this.count = count

    this.xp.getPageConfig(window.location.href).subscribe((config: any) => {
console.log('-- Got Page Config --')
console.log(config)
      this.settings.user = config.user && (config.user.email || config.user.displayName)
      this.settings.customer = config.customer && config.customer.displayName.replace(/^(.*) \(.*\)/, '$1')
      this.settings.isLoggedIn = config.user ? true : false
      if (config.page.data.background) {
console.log(`-- Get background image (${config.page.data.background}) --`)
        const width = window.innerWidth
        const height = window.innerHeight
        config.page.data._background = config.page.data._background.replace(/block-\d+-\d+/, `block-${width}-${height}`)
      }
      this.cache[window.location.href] = {}
      Object.assign(this.cache[window.location.href], config)
      this.config = config
    })
    // this.settings.isLoggedIn || this.router.navigate(['login'])
  }
  ngOnChanges() {
console.log('-- After change --')
// this.onResize()
  }

  onResize(e) {
    console.log('****** resize event --')
    console.log(e.target.getAttribute('data-src'))
    const elements = document.getElementsByClassName('js-image-responsive')
    const n = Array.from(elements)

    console.log('-- resize event -- ' + n.length)
    console.log(elements)
    Array.from(elements).forEach((element) => {
      console.log('-- element --')
      console.log(element)
    })
  }

  ngOnInit() { }

resizeImages(config: any) {
  document.querySelectorAll('.js-image-responsive').forEach((img) => {
    const parent = <HTMLElement>img.parentNode
    const height = parent.offsetHeight
    const width = parent.offsetWidth
    const src = config.page.data.banner.url.replace(/block-\d+-\d+/, `block-${width}-${height}`)
    img.setAttribute('src', src)
  })
}
  menuClick(e: any, location) {
    const page = window.location.href.replace(/^.*?:\/\/[^\/]+/, '')
    console.log(`-- menu -- ${location}:${window.location.href}:${page}`)
    console.log(e)
    history.pushState({}, '', location)
    if (this.cache[location]) {
      console.log('************* use cache --')
      this.config = this.cache[location]
      Object.assign(this.config, this.cache[location])
      this.config.page.data.banner && this.resizeImages(this.config)
      return false
    }
    this.xp.getPageConfig(location).subscribe((config: any) => {
      this.cache[location] = {}
      console.log('************* no cache --')
console.log(this.cache)
      if (config.page.data.background) {
        config.page.data._background = config.page.data._background.replace(/block-\d+-\d+/, `block-${window.innerWidth}-${window.innerHeight}`)
      }
      config.page.data.banner && this.resizeImages(config)
      this.settings.user = config.user && (config.user.email || config.user.displayName)
      this.settings.customer = config.customer && config.customer.displayName.replace(/^(.*) \(.*\)/, '$1')
      this.settings.isLoggedIn = config.user ? true : false
      Object.assign(this.cache[location], config)
      this.config = config
    })
    return false
  }

  logout() {
    this.xp.logout(this.config.page.logout).subscribe((config: any) => {
      console.log('-- logged out --')
    })
    return true;
  }
}
